<template>
    <div class="mb-2 row">
        <label class="col-md-1 col-form-label">{{text.uid}}</label>
        <div class="col-md-2">
            <div class="input-group">
                <input type="text" class="form-control" name="uid" autocomplete="off" v-model="uid" onkeypress='return event.charCode >= 48 && event.charCode <= 57' @input="updated($event.target.value)">
                <div class="input-group-append"><span class="input-group-text" v-bind:class="[uidLengthOk ? 'isGreen' : 'isRed']"><strong>{{uidLen}}</strong></span></div>
            </div>
            <span class="input-error" v-if="error" v-text="error"></span>
        </div>
        <label class="col-md-3 col-form-label">{{text.lookup}}</label>
        <div class="col-md-4 position-relative">
            <input type="text" class="form-control" autocomplete="off" name="lookup" v-model="lookup" @input="doLookup()">
            <ul class="lookupResults" v-if="list.length>0">
                <li v-for="item in list" @click="uidSelected(item.uid)">{{item.name}}, {{item.uid}}</li>
            </ul>
        </div>
    </div>
</template>


<script>
    export default {
        mounted() {
            console.log('Component mounted.')
            this.text.lookup = window.translations.uid_lookup[window.locale]
            this.text.uid = window.translations.uid[window.locale]

        },
        props: {
            uidLength: {
                type: Number,
                default: 7
            },
            error: undefined

        },

        data() {
            return {
                uid: '',
                lookup: '',
                list: [],
                text: {
                  lookup: '',
                  uid: ''
                },

            }
        },
        computed: {
            uidLen() {
                return this.uid.length;
            },
            uidLengthOk() {
                return this.uidLen == this.uidLength;
            }

        },
        methods: {
            updated(uid) {
                this.$emit('input', uid);
            },
            doLookup() {
                axios.post('/client/lookup', { search: this.lookup })
                    .then(response => {
                        console.log(response.data);
                        if(response.data) {
                            this.list = response.data;
                            $(".lookupResults").show();
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        this.list = [];

                    });

            },
            uidSelected(selUid) {
                console.log(selUid);
                this.uid = selUid.trim();
                this.$emit('input', this.uid);
                $(".lookupResults").hide();
            }
        }
    }
</script>
<style>

</style>